import * as sharedTypes from 'src/actions/shared/sharedTypes';
import BusinessHours from 'src/models/BusinessHours/BusinessHours';
import createCollectionResource, { UPDATED_SUCCESSFUL, UpdateOptions } from 'src/actions/shared/createResource';
import backToListView from 'src/actions/shared/backToListView';
import { DomainError as StandardDomainError, Unauthorized } from '@ad-scripts/application/lib/error';
import { logout } from 'src/actions/auth/authSlice';
import { toastError, toastSuccess } from 'src/actions/toast';
import { translateErrors } from 'src/adapters/validateType';

const businessHoursResource = createCollectionResource<BusinessHours>({
  name: 'businessHours',
  endpoint: 'v1/orgs/:orgId/business-hours/:id',
  type: BusinessHours,
});

const update: sharedTypes.AppThunk =
  (params: any, attrs: BusinessHours, opts?: UpdateOptions) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(updateStarted({}));

      await gateways.businessHours.replace(params, { ...attrs, version: attrs.version + 1 });
      dispatch(updateSuccess({}));

      backToListView();

      dispatch(toastSuccess(opts?.customToastMsg || UPDATED_SUCCESSFUL));
    } catch (err) {
      if (err instanceof StandardDomainError) {
        dispatch(updateError(translateErrors(err.errors)));
      } else if (err instanceof Unauthorized) {
        dispatch(logout());
      } else {
        dispatch(updateRequestError(err));
      }
      dispatch(toastError(opts?.customErrorToastMsg || 'There was an error while updating'));
    }
  };

businessHoursResource.effects.update = update;

const { updateStarted, updateSuccess, updateRequestError, updateError } = businessHoursResource.actions;

export default businessHoursResource;
